import { Icon, IconProps } from "@/base/components/icon/Icon.component";
import IconSvg from "./chevron-right.svg?react";

export const ChevronRightIcon = (props: IconProps) => (
  <Icon component={IconSvg} {...props} />
);
